import {
  getLocaleAdMappingFromSlug,
  getLocaleAdMappingFromSlugNonRedundant,
} from 'interfaces/adCategoryMapping'
import camelCase from 'lodash/camelCase'

export const COUNTRY_ADTAG: { [id: string]: string } = {
  'vi-VN': 'MarryBaby',
  'en-PH': 'MarryBaby',
}

export const DEVICE_ADTAG: { [id: string]: string } = {
  MOBILE: 'Mobile',
  DESKTOP: 'Desktop',
  AMP: 'AMP',
}

// 21928898361
export const getAdTag = ({
  countryAdTag,
  contentAdTag,
  forceTag,
  adUnitId = '21682272649',
}: {
  countryAdTag: string
  contentAdTag?: LocaleContentAdTagType
  forceTag?: string
  adUnitId?: string
}) => {
  if (forceTag) return `/${adUnitId}/${countryAdTag}/${forceTag}`
  if (contentAdTag) {
    if (contentAdTag.redundant) {
      return `/${adUnitId}/${countryAdTag}/${countryAdTag}_${contentAdTag.result}`
    }
    return `/${adUnitId}/${countryAdTag}/${contentAdTag.result}`
  }
  return `/${adUnitId}/${countryAdTag}/ad`
}

export const getCountryAdTag = (
  locale: string,
  deviceInfo: {
    isAmp?: boolean | string
    isMobile?: boolean
  },
) => {
  const { isAmp, isMobile } = deviceInfo
  return (
    COUNTRY_ADTAG[locale] +
    (isAmp
      ? DEVICE_ADTAG.AMP
      : isMobile
      ? DEVICE_ADTAG.MOBILE
      : DEVICE_ADTAG.DESKTOP)
  )
}

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
export const getCategoryAdTag = (href: string) => {
  return href
    .split('/')
    .filter(Boolean)
    .map((slug) => capitalizeFirstLetter(camelCase(slug)))
    .join('/')
}

export type LocaleContentAdTagType = {
  result: string
  redundant: boolean
}
export const getLocaleCategoryAdTag = (
  locale: string,
  href: string,
): LocaleContentAdTagType | undefined => {
  const foundMapping = getLocaleAdMappingFromSlug(locale, decodeURI(href))
  const foundNonRedundantMapping = getLocaleAdMappingFromSlugNonRedundant(
    locale,
    decodeURI(href),
  )
  if (!foundMapping && !foundNonRedundantMapping) {
    return {
      result: getCategoryAdTag(href),
      redundant: true,
    }
  }
  return {
    result: foundMapping || foundNonRedundantMapping || '',
    redundant: !!foundMapping,
  }
}
export const getCategorySlugFromArticleSlug = (href: string): string => {
  const slugs = href.split('/').filter(Boolean)
  slugs.pop()
  return slugs.join('/')
}
